export default __webpack_public_path__ + "static/cointribune-f52be8a8685cd14dff7b60fd266c41c6.png";